import Parse from "parse";
import { getClassName, filterKeys } from "./ParseConfiguration";
import { handleError } from "./ErrorHandler.ts";
import { EmailConfigurationModel } from "../Models/EmailConfigurationModel";


const EMAIL_CONFIGURATION = getClassName("EmailConfiguration")


export async function getEmailConfiguration() {
  try {
    const query = new Parse.Query(EMAIL_CONFIGURATION)
    const result = await query.find()

    return result.map((parseObject) =>
      EmailConfigurationModel.convertFromParseObject(parseObject)
    )
  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function addOrUpdateEmailConfiguration(newConfiguration) {
  try {
    const EmailConfiguration = EMAIL_CONFIGURATION
    const configuration = new EmailConfiguration()
    Object.entries(newConfiguration)
      .filter((key) => !filterKeys.includes(key[0]))
      .forEach((key) => {
        configuration.set(key[0], key[1])
      })
    await configuration.save()

  } catch (error) {
    handleError(error)
    throw error
  }
}
